<template>
    <div class="animated fadeIn">
      <b-button
        type="button"
        size="sm"
        variant="primary"
        v-on:click="saveNews"
        :disabled="disabled"
      ><i class="fa fa-plus" ></i>Save
      </b-button>
    </div>
</template>
<script>
    import {News} from "../../../models/News/News";
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {handleErrors} from "../../../shared/utils";

    export default {
        name: 'news-save-btn',
        props: {
          news: {
            type: Object,
            default: new News(),
          },
          disabled: {
            type: Boolean,
            default: false,
          },
        },
        methods: {
          saveNews() {
            this.$emit('click', true)
            this.disabled = true
            let payload = {
              name: this.news.name,
              content: this.news.content,
              publishedAt: this.$moment(this.news.publishedAt).format('YYYY-MM-DD')+'T00:00:00+01:00',
              isAction: this.news.isAction,
              externalLink: this.news.externalLink,
              videoLink: this.news.videoLink,
              categories: this.news.categories
            }

            console.log(payload)
            RepositoryFactory
              .get('news')
              .updateNews(this.news.id, payload)
              .then(
                response =>
                  (
                    this.$emit('success', response.data.data)
                  )
              )
              .catch(
                response => (
                  this.returnErrors(response)
                )
              )
          },
          returnErrors(response) {
            this.$emit('click', false)
            handleErrors(response).forEach(
              value => {
                this.flash(value,'error')
              }
            )
          },
        },
    }
</script>
